module.exports = __webpack_public_path__ + "img/computer_c.7f63a2ad.svg";